/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import * as React from 'react';

/* eslint-disable no-unused-vars */
import ErrorState from '../ErrorState/ErrorState';
import AnalyticsUtil from '../../../utils/AnalyticsUtil';

/* eslint-enable no-unused-vars */

type Props = {
	children?: React.ReactNode;
	locale: string;
};

interface State {
	hasError: boolean;
	error: any | null | undefined;
	errorInfo: any;
}

class ErrorBoundary extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			hasError: false,
			error: null,
			errorInfo: {},
		};
	}

	componentDidCatch(error: Object | null | undefined, errorInfo: Object) {
		// Display fallback UI
		this.hideTransitionLoader();
		this.setState({
			hasError: true,
			error,
			errorInfo,
		});
	}

	getErrorType() {
		return {
			params: {
				type: '2',
			},
		};
	}

	hideTransitionLoader() {
		document.getElementsByTagName('body')[0].classList.remove('bodyOverflowHidden');
		const transitionLoader: HTMLElement | null = document.querySelector('.transition-screen-wrapper.apps');
		if (transitionLoader) {
			transitionLoader.style.display = 'none';
		}
	}

	sendRedirectAnalytic(reason: string, errorDesc: string | null | undefined) {
		const analytics = new AnalyticsUtil();
		analytics.sendRedirectAnalytic('js-error', window.location.href, reason, errorDesc);
	}

	render() {
		if (this.state.hasError) {
			// show the 5xx error state.
			const reason = this.state.error && this.state.error.message ? this.state.error.message : 'unknown-error';
			window.cchome.util.logger.error('error boundary', reason);
			this.sendRedirectAnalytic(reason, this.state.errorInfo.componentStack);
			return <ErrorState.component match={this.getErrorType()} locale={this.props.locale} />;
		}
		return this.props.children;
	}
}

export default ErrorBoundary;
